export var gtagEvent = function gtagEvent(_ref) {
  var action = _ref.action,
    tag = _ref.tag,
    value = _ref.value;
  process.browser && window.gtag && window.gtag('event', action, {
    allow_custom_scripts: true,
    send_to: "".concat(tag, "/").concat(value)
  });
};